export class JobProgressStepTableCreationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceArn",
            "baseName": "resourceArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "alreadyExisted",
            "baseName": "alreadyExisted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "throughputMode",
            "baseName": "throughputMode",
            "type": "string",
            "format": ""
        },
        {
            "name": "writeCapacityUnits",
            "baseName": "writeCapacityUnits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "warmThroughputWriteUnitsPerSecond",
            "baseName": "warmThroughputWriteUnitsPerSecond",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "keyspaceName",
            "baseName": "keyspaceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountName",
            "baseName": "accountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "defaultTimeToLive",
            "baseName": "defaultTimeToLive",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "consoleUrl",
            "baseName": "consoleUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepTableCreationData.attributeTypeMap;
    }
    constructor() {
    }
}
